import { CustomRouteConfig } from "@brightagency/headstart-common";
import { Home } from "../components/templates/Home";
import { ListingTemplate } from "../components/templates/ListingTemplate";
import { LocalInformationTemplate } from "../components/templates/LocalInformationTemplate";
import { PageTemplateChooser } from "../components/templates/PageTemplateChooser";
import { PostTypePageTemplate } from "../components/templates/PostTypePageTemplate";
import { State, BoundActions } from "../services/app-state/types";

export const Routes: CustomRouteConfig<{
    actions: BoundActions;
    store: State;
}>[] = [
    {
        path: "/",
        exact: true,
        component: Home,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
    {
        path: "/service/:slug",
        exact: true,
        component: ListingTemplate,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
    {
        path: "/support-for/:slug",
        exact: true,
        component: PostTypePageTemplate,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
    {
        path: "/disorder-or-concern/:slug",
        exact: true,
        component: PostTypePageTemplate,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
    {
        path: "/challenging-situations/:slug",
        exact: true,
        component: PostTypePageTemplate,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
    {
        path: "/local-information/:slug/:slug",
        exact: true,
        component: LocalInformationTemplate,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
    {
        path: "*",
        component: PageTemplateChooser,
        preload: async ({ passed, location }) => {
            await passed.actions.getRouteData(location.pathname);
        },
    },
];
